import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useTranslation } from 'react-i18next'
import {
  openExternalUrl,
  usePreviousState
} from 'src/libs/qb-brand-web-components'
import { useBoolean } from 'minimal-shared/hooks'

import Cashback from '../components/cashback/Cashback'
import {
  changeCashbackState,
  // getCashbackBrandDetails,
  getCashbackBrands,
  getCashbackBrandsBySearch,
  getFilterCategories,
  resetCashbackState,
  selectCategoryForFilter
} from '../store/actions/cashback'
import { createCashbackTrackingUrl } from '../util/cashback.helpers'
import { CASHBACK_PROFILE_DISPATCH } from '../store/reducers/cashback/cashback'
import { useDebounce } from '../hooks/useDebounce'

const CashbackContainer = ({
  getCashbackBrands,
  getCashbackBrandsBySearch,
  getFilterCategories,
  cashbackProfile,
  accountProfile,
  // getCashbackBrandDetails,
  changeCashbackState,
  resetCashbackState,
  selectCategoryForFilter
}) => {
  const { t } = useTranslation()
  const {
    cashbackBrands,
    page,
    totalPages,
    isLast,
    loading,
    loadingBrand,
    filterCategories,
    // loadingDetails,
    checkedCategoriesForFilter
  } = cashbackProfile
  const { authId } = accountProfile

  const [query, setQuery] = useState('')

  const debouncedQuery = useDebounce(query)

  const prevQuery = usePreviousState(debouncedQuery)

  const openFilters = useBoolean()

  useEffect(() => {
    if (debouncedQuery.trim() !== '') {
      handleSearch(debouncedQuery)
    }
    if (prevQuery && !openFilters.value) {
      handleSearch()
    }
  }, [debouncedQuery])

  useEffect(() => {
    getCashbackBrands(0, true, false)
    getFilterCategories()
  }, [])

  useEffect(() => {
    return () => {
      resetCashbackState()
    }
  }, [])

  // useEffect(() => {
  //   if (selectedCashbackBrand) {
  //     if (!selectedCashbackBrand.trackingUrl) {
  //       getCashbackBrandDetails(selectedCashbackBrand.id)
  //     }
  //   }
  // }, [selectedCashbackBrand])

  const handleScroll = useCallback(() => {
    const currentPage = page + 1
    if (
      page < totalPages &&
      currentPage !== totalPages &&
      !query &&
      !loadingBrand
    ) {
      getCashbackBrands(currentPage, false, true)
    }
  }, [page, cashbackBrands, query])

  const handleCashbackShopNow = (trackingUrl) => {
    const url = createCashbackTrackingUrl(trackingUrl, authId)
    openExternalUrl(url)
  }

  const handleClearAll = () => {
    handleCancelFilters()
    getCashbackBrands(0, true, false)
  }

  const handleSearch = (searchTerm) => {
    if (searchTerm) {
      getCashbackBrandsBySearch(searchTerm, 0, true, false)
    } else {
      getCashbackBrands(0, true, false)
    }
    changeCashbackState(
      CASHBACK_PROFILE_DISPATCH.CHECKED_CATEGORIES_FOR_FILTER,
      {}
    )
  }

  const handleCancelFilters = () => {
    changeCashbackState(
      CASHBACK_PROFILE_DISPATCH.CHECKED_CATEGORIES_FOR_FILTER,
      {}
    )
  }

  const handleFilterItem = (id) => {
    setQuery('')
    selectCategoryForFilter(id)
  }

  return (
    <Cashback
      t={t}
      query={query}
      setQuery={setQuery}
      cashbackBrands={cashbackBrands}
      onCashbackShopNowClick={handleCashbackShopNow}
      checkedCategoriesForFilter={checkedCategoriesForFilter}
      loading={loading}
      scrollDataProps={{
        next: handleScroll,
        hasMore: !query && !isLast
      }}
      openFilters={openFilters}
      onClearAll={handleClearAll}
      filterCategories={filterCategories}
      onListItemClick={handleFilterItem}
      // loadingDetails={loadingDetails}
    />
  )
}

const mapStateToProps = ({ cashbackReducer, accountReducer }) => {
  const { cashbackProfile } = cashbackReducer
  const { accountProfile } = accountReducer
  return {
    cashbackProfile,
    accountProfile
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCashbackBrands,
      getCashbackBrandsBySearch,
      getFilterCategories,
      // getCashbackBrandDetails,
      changeCashbackState,
      resetCashbackState,
      selectCategoryForFilter
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(CashbackContainer)
